<template>
  <div class="pm50">
    <div class="pd jhnstop row">
      <p class="col">
        <img src="../../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome">首页</span>
    </div>
    <div>
      <div class="pd pt20">
        <div v-if="loading1">
          <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
        </div>
        <van-row v-else class="yj4 jhndsrte cen">
          <van-col span="12">
            <p class="fz14 z3">今日接待总数</p>
            <p class="fz24 ls mt5">{{ todayCheckInNum }}</p>
          </van-col>
          <van-col span="12" class="sdfyyuwe">
            <p class="fz14 z3">本月接待总数</p>
            <p class="fz24 zts mt5">{{ monthCheckInNum }}</p>
          </van-col>
        </van-row>

        <p class="mt20">
          <span class="jjnjjjert">各区域参观情况</span>
        </p>
        <div v-if="loading2">
          <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
        </div>
        <div class="kjmmsdttyew mt20" v-else-if="shuju.xAxis[0].data.length > 0">
          <tubiao v-model="shuju"></tubiao>
        </div>
        <div v-else>
          <no-data :content-height="80"></no-data>
        </div>
        <p class="mt20">
          <span class="jjnjjjert">展馆实时客流</span>
        </p>
        <div v-if="loading3">
          <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
        </div>
        <div class="jinunjser" v-else-if="stadiumTicketCheckData.rows.length > 0">
          <div
            class="row mt10"
            v-for="(row, idx) in stadiumTicketCheckData.rows"
            :key="row.gateName"
          >
            <p class="kjnmkxer fz14 z3">{{ row.gateName }}</p>
            <div class="gdfyuywwr ml10">
              <span :style="getWidth(stadiumTicketCheckData, idx)"></span>
            </div>
            <p class="col z3 fz14 tr areanum">{{ row.realTime }}</p>
          </div>
        </div>
        <div v-else>
          <no-data :content-height="80"></no-data>
        </div>

        <p class="mt30">
          <span class="jjnjjjert">团队接待情况</span>
        </p>
        <div v-if="loading4">
          <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
        </div>
        <van-grid
        v-else-if="statOrdersByTicketTypeData.length > 0"
        :border="false"
        :column-num="3"
        class="mt20 cen"
        >
          <van-grid-item
            v-for="(data,idx) in statOrdersByTicketTypeData"
            :key="data.tickettypename"
          >
            <div class="yj jkkjmjkxeert f_b " :class="[idx%2==1?'ab':'']">
              <div class="w100 h100 bgff ov yj sdgffdyse pr">
                <p class="fz14 z9 cen dsfstrtw">接待数量</p>
                <p class="fz24 ls cen">{{ data.orderCount }}</p>
                <div class="pr fdgyw3eert ov">
                  <span class="mnjjnjjwer"></span>
                  <span class="mnjjnjjwer ab"></span>
                  <div class="kjnmkkxert yj"></div>
                </div>
              </div>
            </div>
            <p class="fz13 z3 mt15">{{ data.ticketTypeName }}</p>
          </van-grid-item>
        </van-grid>
        <div v-else>
          <no-data :content-height="80"></no-data>
        </div>
        <!-- <van-row class="mt20 cen">
          <van-col span="8">
            <div class="yj jkkjmjkxeert f_b">
              <div class="w100 h100 bgff ov yj sdgffdyse pr">
                <p class="fz14 z9 cen dsfstrtw">接待数量</p>
                <p class="fz24 ls cen">345</p>
                <div class="pr fdgyw3eert ov">
                  <span class="mnjjnjjwer"></span>
                  <span class="mnjjnjjwer ab"></span>
                  <div class="kjnmkkxert yj"></div>
                </div>
              </div>
            </div>
            <p class="fz13 z3 mt15">林则徐纪念馆</p>
          </van-col>
          <van-col span="8">
            <div class="yj jkkjmjkxeert f_b ab">
              <div class="w100 h100 bgff ov yj sdgffdyse pr">
                <p class="fz14 z9 cen dsfstrtw">接待数量</p>
                <p class="fz24 ls cen">345</p>
                <div class="pr fdgyw3eert ov">
                  <span class="mnjjnjjwer"></span>
                  <span class="mnjjnjjwer ab"></span>
                  <div class="kjnmkkxert yj"></div>
                </div>
              </div>
            </div>
            <p class="fz13 z3 mt15">威远炮台旧址</p>
          </van-col>

          <van-col span="8">
            <div class="yj jkkjmjkxeert f_b">
              <div class="w100 h100 bgff ov yj sdgffdyse pr">
                <p class="fz14 z9 cen dsfstrtw">接待数量</p>
                <p class="fz24 ls cen">345</p>
                <div class="pr fdgyw3eert ov">
                  <span class="mnjjnjjwer"></span>
                  <span class="mnjjnjjwer ab"></span>
                  <div class="kjnmkkxert yj"></div>
                </div>
              </div>
            </div>
            <p class="fz13 z3 mt15">海战博物馆</p>
          </van-col>
        </van-row> -->

        <p class="mt30">
          <span class="jjnjjjert">讲解接待情况</span>
        </p>
        <div v-if="loading5">
          <van-loading class="loading" size="24px" type="spinner" vertical>加载中...</van-loading>
        </div>
        <van-grid
        v-else-if="statOrdersByTicketTypeData2.length > 0"
        :border="false"
        :column-num="3"
        class="mt20 cen"
        >
          <van-grid-item
            v-for="(data,idx) in statOrdersByTicketTypeData2"
            :key="data.tickettypename"
          >
            <div class="yj jkkjmjkxeert f_b " :class="[idx%2==1?'ab':'']">
              <div class="w100 h100 bgff ov yj sdgffdyse pr">
                <p class="fz14 z9 cen dsfstrtw">接待数量</p>
                <p class="fz24 ls cen">{{ data.orderCount }}</p>
                <div class="pr fdgyw3eert ov">
                  <span class="mnjjnjjwer"></span>
                  <span class="mnjjnjjwer ab"></span>
                  <div class="kjnmkkxert yj"></div>
                </div>
              </div>
            </div>
            <p class="fz13 z3 mt15">{{ data.ticketTypeName }}</p>
          </van-grid-item>
        </van-grid>
        <div v-else>
          <no-data :content-height="80"></no-data>
        </div>
        <!-- <van-row class="mt20 cen">
          <van-col span="8">
            <div class="yj jkkjmjkxeert f_b">
              <div class="w100 h100 bgff ov yj sdgffdyse pr">
                <p class="fz14 z9 cen dsfstrtw">接待数量</p>
                <p class="fz24 ls cen">345</p>
                <div class="pr fdgyw3eert ov">
                  <span class="mnjjnjjwer"></span>
                  <span class="mnjjnjjwer ab"></span>
                  <div class="kjnmkkxert yj"></div>
                </div>
              </div>
            </div>
            <p class="fz13 z3 mt15">林则徐纪念馆</p>
          </van-col>
          <van-col span="8">
            <div class="yj jkkjmjkxeert f_b ab">
              <div class="w100 h100 bgff ov yj sdgffdyse pr">
                <p class="fz14 z9 cen dsfstrtw">接待数量</p>
                <p class="fz24 ls cen">345</p>
                <div class="pr fdgyw3eert ov">
                  <span class="mnjjnjjwer"></span>
                  <span class="mnjjnjjwer ab"></span>
                  <div class="kjnmkkxert yj"></div>
                </div>
              </div>
            </div>
            <p class="fz13 z3 mt15">接待数量</p>
          </van-col>

          <van-col span="8">
            <div class="yj jkkjmjkxeert f_b">
              <div class="w100 h100 bgff ov yj sdgffdyse pr">
                <p class="fz14 z9 cen dsfstrtw">接待数量</p>
                <p class="fz24 ls cen">345</p>
                <div class="pr fdgyw3eert ov">
                  <span class="mnjjnjjwer"></span>
                  <span class="mnjjnjjwer ab"></span>
                  <div class="kjnmkkxert yj"></div>
                </div>
              </div>
            </div>
            <p class="fz13 z3 mt15">海战博物馆</p>
          </van-col>
        </van-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState,mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import "v-charts/lib/style.css";
import tubiao from "@/components/tubiao";
import moment from "moment";
import ticketService from "@/services/ticketService.js";
import orderService from "@/services/orderService.js";
import NoData from "@/components/NoData.vue";
const today = moment().format("YYYY-MM-DD");

function Shuju() {
  this.tooltip = {
    trigger: "axis",
    axisPointer: {
      // 坐标轴指示器，坐标轴触发有效
      type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
    },
  };
  this.legend = {
    data: ["园内时实客流", "今日接待人数"],
  };
  this.grid = {
    left: "3%",
    right: "4%",
    bottom: "3%",
    top: "10%",
    containLabel: true,
  };
  this.xAxis = [
    {
      type: "category",
      data: [
        // "林则徐纪念馆",
        // "威远炮台旧址",
        // "沙角炮台旧址",
        // "沙角炮台旧址",
        // "海战博物馆",
      ],
      axisTick: {
        alignWithLabel: true,
      },
      axisLine: {
        //最外面的边框颜色
        lineStyle: {
          color: "#999999",
        },
      },
      axisLabel: {
        rotate: 45,
      },
    },
  ];
  this.yAxis = [
    {
      type: "value",
      axisLine: {
        //最外面的边框颜色
        lineStyle: {
          color: "#999999",
        },
      },
    },
  ];
  this.series = [
    {
      name: "园内时实客流",
      type: "bar",
      stack: "总量",
      color: "#3C8046",
      label: {
        show: true,
        position: "insideRight",
      },
      barWidth: "40%",
      data: [],
    },
    {
      name: "今日接待人数",
      type: "bar",
      stack: "总量",
      label: {
        show: true,
        position: "insideRight",
      },
      barWidth: "40%",
      color: "#3C7080",
      data: [],
    },
  ];
}

export default {
  components: {
    tubiao,
    NoData,
  },
  data() {
    return {
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false,
      widths: "style='width: 80%'",
      todayCheckInNum: 0,
      monthCheckInNum: 0,
      shuju: new Shuju(),
      stadiumTicketCheckData: {
        rows: [],
        totalRealTimeNum: 0,
      },
      statOrdersByTicketTypeData:[],
      statOrdersByTicketTypeData2:[]
    };
  },
  methods: {
    toHome() {
      this.$router.push("/");
    },
    getWidth(data, idx) {
      if (data.totalRealTimeNum == 0) {
        return "width:0%";
      }
      let width = parseInt((data.rows[idx].realTime / data.totalRealTimeNum) * 100);
      return "width:" + width + "%";
    },
    loadData() {
      this.loading1 = true;
      this.loading2 = true;
      this.loading3 = true;
      this.loading4 = true;
      this.loading5 = true;
      const monthCheckInNum = ticketService
        .getScenicCheckInQuantityAsync({
          StartDate: moment().format("YYYY-MM-01"),
          EndDate: today,
        })
        .then((response) => {
          this.monthCheckInNum = response;
        });

      const todayCheckInNum = ticketService
        .getScenicCheckInQuantityAsync({
          StartDate: today,
          EndDate: today,
        })
        .then((response) => {
          this.todayCheckInNum = response;
        });

      Promise.all([monthCheckInNum, todayCheckInNum])
        .then(() => {

        })
        .catch(() => {

        })
        .finally(() => {
          this.loading1 = false;
        });

      ticketService
        .getRealTimeGroundTicketCheckOverview2Async({
          StartDate: today,
          EndDate: today,
        })
        .then((result) => {
          this.shuju.xAxis[0].data = [];
          this.shuju.series[0].data = [];
          this.shuju.series[0].name = "园内时实客流";
          this.shuju.series[0].color = "#3C8046";
          this.shuju.series[1].data = [];
          this.shuju.series[1].name = "今日接待人数";
          this.shuju.series[1].color = "#3C7080";
          for (var i = 0; i < result.length; i++) {
            this.shuju.xAxis[0].data.push(result[i].groundname);

            this.shuju.series[0].data.push(result[i].realTime);

            this.shuju.series[1].data.push(result[i].checkinnum);
          }
        }).catch(() => {

        })
        .finally(() => {
          this.loading2 = false;
        });

      ticketService
        .getStadiumTicketCheckOverviewAsync({
          startDate: today,
          endDate: today,
        })
        .then((response) => {
          this.stadiumTicketCheckData.rows = response;
          var totalNum = 0;
          for (var i = 0; i < response.length; i++) {
            if(this.parkCloseTime)
            {
              response[i].checkIn = 0;
              response[i].checkOut = 0;
              response[i].realTime = 0;
            }
            totalNum += response[i].realTime;    
          }
          this.stadiumTicketCheckData.totalRealTimeNum = totalNum;
        }).catch(() => {

        })
        .finally(() => {
          this.loading3 = false;
        });
      orderService
        .statOrdersByTicketTypeAsync({
                        startTravelDate: today,
                        endTravelDate: today,
                        hasCustomer: true,
                        hasCheckIn: true
                    })
        .then((result) => {

           this.statOrdersByTicketTypeData = result.data;
        }).catch(() => {

        })
        .finally(() => {
          this.loading4 = false;
        });

      orderService
        .statOrdersByTicketTypeAsync({
                        startTravelDate: today,
                        endTravelDate: today,
                        hasCustomer: true,
                        hasCheckIn: true,
                        HasExplainer: true,
                    })
        .then((result) => {

           this.statOrdersByTicketTypeData2 = result.data;
        }).catch(() => {

        })
        .finally(() => {
          this.loading5 = false;
        });
    },
    ...mapActions("orderModule", [appConsts.loadOrderOptionsAsync]),
  },
  mounted() {},
  created() {
    this.loadData();
  },
  computed: {
    ...mapState({
      options: (state) => state.orderModule.options
    }),
    parkCloseTime(){
      var ctime = moment().format("HH:mm");
      if(ctime>=this.options.parkCloseTime)
      {
          return true;
      }else{
        return false;
      }
    }
  },
};
</script>

<style scoped>
.jhndsrte {
  background: #f2ede9;
  border: 1px solid #e5dedd;
  padding-top: 15px;
  padding-bottom: 13px;
}

.sdfyyuwe {
  border-left: 1px solid #cbaba7;
}

.kjmmsdttyew {
  height: 300px;
}

.kjnmkxer {
  width: 20%;
}
.gdfyuywwr {
  width: 80%;
  top: 3px;
}

.loading{
  margin-top: 100px;
  text-align: center;
}
.areanum{
  position: absolute;
    right: 15px;
    z-index: 100;
    margin-top: 2px;
}
</style>